const PropertyMap = ({ lat, lng, title }) => {
  const hasCoordinates =
    Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));

  if (!hasCoordinates) {
    return (
      <div className="mt-8 overflow-hidden rounded-2xl border bg-white p-5">
        <h2 className="mb-2 text-lg font-bold">Ubicacion</h2>
        <p className="text-sm text-gray-500">
          Esta propiedad todavia no tiene coordenadas listas para mostrar el
          mapa interactivo.
        </p>
      </div>
    );
  }

  const query = `${Number(lat)},${Number(lng)}`;
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${query}`;
  const embedUrl = `https://www.google.com/maps?q=${query}&z=17&output=embed`;

  return (
    <div className="relative z-0 mt-8 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <a
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute right-3 top-3 z-10 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-blue-700 shadow hover:bg-blue-50"
      >
        Abrir en Google Maps
      </a>

      <iframe
        title={title || "Ubicacion de la propiedad"}
        src={embedUrl}
        className="h-[350px] w-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
  );
};

export default PropertyMap;
